import { render, staticRenderFns } from "./LicenseFilter.vue?vue&type=template&id=070d4c38&"
import script from "./LicenseFilter.vue?vue&type=script&lang=js&"
export * from "./LicenseFilter.vue?vue&type=script&lang=js&"
import style0 from "./LicenseFilter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports